/* eslint-disable max-len */
import React, { useCallback, useEffect } from 'react';
import AvaterImage from '../../../components/AvaterImage';
import DashboardHeaderWithFilters from '../../../components/DashboardHeaderWithFilters';
import Dots from '../../../components/Loading/Dots';
import { GET_REFERRAL_DETAILES_BY_USER_ID } from '../../../graphql/admin_queries';
import useCustomQuery from '../../../network/useCustomQuery';
import ReloadIcon from '../../../svgs/ReloadIcon';
import { dateFormatter } from '../../../utils/helpers';
import Styles from './RewardDetailsCard.module.scss';

interface IRewardDetailsCard{
  rewardId,
  setReferralId:any;
}
const RewardDetailsCard = ({ rewardId, setReferralId }:IRewardDetailsCard) => {
  const [getReferralDetailsById, loading, data] = useCustomQuery({
    query: GET_REFERRAL_DETAILES_BY_USER_ID,
    onError: () => {},
    onData: () => {},
  });

  const fetchReferralDetailsById = useCallback(
    () => getReferralDetailsById({ variables: { userId: rewardId } }),
    [rewardId],
  );

  useEffect(() => {
    fetchReferralDetailsById();
  }, []);

  useEffect(() => {
    if (data?.getReferralDetailsByUserId?.id) {
      setReferralId(data?.getReferralDetailsByUserId?.id);
    }
  }, [data]);

  const details = [
    {
      title: 'Customer',
      value: `${data?.getReferralDetailsByUserId?.user
        ?.firstName} ${data?.getReferralDetailsByUserId?.user
        ?.lastName}`,
      col: 'col-xl-3 col-md-6',
    },
    { title: 'Amount earned', value: `$${data?.getReferralDetailsByUserId?.earnings || 0}`, col: 'col-xl-2 col-md-6' },
    { title: 'Amount withdrawn', value: '$0', col: 'col-xl-2 col-md-6' },
    { title: 'No. of referrals', value: `${data?.getReferralDetailsByUserId?.totalReferred || 0}`, col: 'col-xl-2 col-md-6' },
    { title: 'Date onboarded', value: dateFormatter(new Date(Number(data?.getReferralDetailsByUserId?.user?.createdAt)), 'MMM DD, YYYY hh:mm a', '**********'), col: 'col-xl-3 col-md-6' },
  ];

  return (
    <div className={Styles.wrapper}>
      <div className={Styles.wrapper__avatarAndId}>
        <div className={Styles.wrapper__avatar}>
          <AvaterImage image={data?.getReferralDetailsByUserId?.user?.imageUrl} width="40px" height="40px" />
        </div>
        <div className={Styles.wrapper__Id}>{data?.getReferralDetailsByUserId?.referralCode}</div>
      </div>
      <div className={Styles.wrapper__detailsAndAction}>
        <div className={Styles.wrapper__details}>
          <div className={`row ${Styles.wrapper__detailsRow}`}>
            {
              details?.map((list, index) => (
                <div className={`${list?.col} ${Styles.wrapper__detailsCol}`} key={index}>
                  <div className={Styles.wrapper__detailsTitle}>{list?.title}</div>
                  <div className={Styles.wrapper__detailsValue}>

                    {loading ? <div className={Styles.wrapper__detailsLoader}><Dots /></div> : list?.value}

                  </div>
                </div>
              ))
            }
          </div>
        </div>
        <div className={Styles.wrapper__action}>
          <div className={Styles.wrapper__actionReLoad}>
            {
              !loading && <span onClick={() => fetchReferralDetailsById()}><ReloadIcon /></span>
            }

          </div>
          <div>
            <DashboardHeaderWithFilters />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RewardDetailsCard;
